<div class="label-picker-menu" (click)="$event.stopPropagation()">
  <span class="label-picker-menu__heading" data-testid="label-picker-heading" *ngIf="showList">{{ 'smart_inbox.inbox_view.label_picker.heading' | translate }}</span>

  <div class="label-picker-menu__list" *ngIf="showList">
    <ng-container *ngFor="let label of offerableLabels; trackBy: trackByLabelId">
      <button
        type="button"
        class="navbar-button label-picker-menu__item"
        data-testid="label-option"
        [attr.data-label-id]="label.id"
        [title]="label.name"
        (click)="toggleLabel(label)"
      >
        <span class="label-picker-menu__check-slot" [class.is-checked]="isApplied(label)">
          <ui-svg-icon *ngIf="isApplied(label)" svgIcon="check-cc" size="small" data-testid="label-option-check"></ui-svg-icon>
        </span>
        <ui-svg-icon svgIcon="tag-cc" size="small" class="label-picker-menu__tag" [style.color]="label.color"></ui-svg-icon>
        <span class="label-picker-menu__item-name">{{ label.name }}</span>
      </button>
    </ng-container>

    <div *ngIf="loading" class="label-picker-menu__status" data-testid="label-picker-loading">
      {{ 'smart_inbox.inbox_view.label_picker.loading' | translate }}
    </div>

    <!-- Suppressed while a create row is offered: "No labels found" above
         "Create <name>" says the same thing twice, and the second one is the
         one the user can act on. -->
    <div *ngIf="isEmpty && !loadFailed && !canCreateTypedName"
         class="label-picker-menu__status" data-testid="label-picker-empty">
      {{ 'smart_inbox.inbox_view.label_picker.no_labels_found' | translate }}
    </div>

    <!-- Reading the catalogue needs a settings permission that applying one does
         not, so say what is missing and leave the create row working. -->
    <div *ngIf="loadFailed" class="label-picker-menu__status" data-testid="label-picker-load-failed">
      {{ 'smart_inbox.inbox_view.label_picker.list_unavailable' | translate }}
    </div>
  </div>

  <ng-container *ngIf="canCreateTypedName">
    <hr class="separator" />
    <button
      type="button"
      class="navbar-button label-picker-menu__create-option"
      data-testid="label-create-option"
      (click)="createTypedName()"
    >
      <ui-svg-icon svgIcon="plus-cc" size="medium"></ui-svg-icon>
      <span>{{ 'smart_inbox.inbox_view.label_picker.create_and_apply' | translate: { name: searchTerm } }}</span>
    </button>
  </ng-container>

  <ng-container *ngIf="hiddenNameCollision">
    <hr class="separator" />
    <div class="label-picker-menu__status" data-testid="label-hidden-collision">
      {{ 'smart_inbox.inbox_view.label_picker.hidden_name_taken' | translate: { name: searchTerm } }}
    </div>
  </ng-container>

  <hr class="separator" />

  <div class="label-picker-menu__create">
    <input
      #searchInput
      type="text"
      data-testid="label-picker-search"
      class="label-picker-menu__create-input"
      [formControl]="searchControl"
      [placeholder]="'smart_inbox.inbox_view.label_picker.placeholder_search' | translate"
      (keydown.enter)="createTypedName()"
    />
    <button type="button"
            class="label-picker-menu__create-button"
            [class.is-armed]="canCreateTypedName"
            [disabled]="!canCreateTypedName"
            data-testid="label-picker-create"
            [attr.aria-label]="'smart_inbox.inbox_view.label_picker.create' | translate"
            (click)="createTypedName()">
      <ui-svg-icon svgIcon="plus-cc" size="small"></ui-svg-icon>
    </button>
  </div>
</div>
